"use strict";

(function () {
  'use strict';

  angular.module('lr.Map').directive('openMap', ['$log', '$timeout', 'Utils', 'dataEvents', 'MapFactory', '$filter', 'EventSettingsFactory', function ($log, $timeout, Utils, dataEvents, MapFactory, $filter, EventSettingsFactory) {
    return {
      restrict: 'AE',
      scope: {
        data: '=',
        height: '=',
        width: '=',
        eventsOnly: '='
      },
      link: function link(scope, ele, attrs) {
        var renderTimeout;
        var DEFAULTS = {
          id: attrs.id || 'map',
          height: 730,
          width: 500,
          zoom: 3,
          lat: 28.331177,
          "long": -81.608208,
          maxZoom: 18,
          tileServer: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          scrollWheelZoom: false
        };
        var height = scope.height || ele.height() === 0 ? DEFAULTS.height : ele.height();
        var width = scope.width || ele.width() === 0 ? DEFAULTS.width : ele.width();
        var liveRezMap = new MapFactory.Map(L, DEFAULTS);
        var liveRezPinLayer = new MapFactory.MapLayer().addTo(liveRezMap.mapInstance); //On new events

        if (!Utils.Publisher.hasEvent(dataEvents.newEvent)) {
          Utils.Publisher.subscribe(dataEvents.newEvent, function (topic, data) {
            try {
              data = $filter('eventsFilter')([data], EventSettingsFactory.eventFilters);

              if (data && data.length > 0 && data[0] && data[0].propertyLatitude) {
                liveRezMap.createPin(data[0]);
                liveRezPinLayer.clearLayers();
                liveRezMap.update(liveRezPinLayer);
                liveRezMap.mapInstance.fitBounds(liveRezMap.bounds);
              }
            } catch (ex) {}
          });
        } //On Data Changes


        scope.$watch('data', function (newData) {
          if (newData) {
            scope.render(newData);
          }
        }, true); //Render

        scope.render = function (data) {
          var pins = data;

          if (scope.eventsOnly) {
            pins = $filter('eventsFilter')(pins, EventSettingsFactory.eventFilters);
          }

          if (pins.length <= 0) {
            liveRezMap.resetData();
            liveRezPinLayer.clearLayers();
            liveRezMap.update(liveRezPinLayer);
            return;
          }

          if (renderTimeout) {
            clearTimeout(renderTimeout);
          }

          renderTimeout = $timeout(function () {
            liveRezPinLayer.clearLayers();

            for (var i = 0; pins.length > i; i++) {
              liveRezMap.createPin(pins[i]);
            }

            liveRezMap.update(liveRezPinLayer);

            if (liveRezMap.bounds.length > 0) {
              liveRezMap.mapInstance.fitBounds(liveRezMap.bounds);
            }
          }, 500);
        };

        scope.$on('$destroy', function () {
          $(window).off('resize');
        }); //Force the Map to be the correct size.

        $(window).on('resize', function () {
          $('#' + DEFAULTS.id).height(height).width(width);
          liveRezMap.mapInstance.invalidateSize();
        }).trigger('resize');
      },
      template: '<div id="map"></div>'
    };
  }]);
})();